import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss'],
  providers: [NgbModalConfig, NgbModal]

})
export class AccueilComponent implements OnInit {
  closeResult = '';
  modalRef: NgbModalRef | undefined;

  constructor(private modalService: NgbModal,config: NgbModalConfig,) {
    config.backdrop = 'static';
    config.keyboard = false;
   }

  ngOnInit(): void {
  }

  open(content: any) {
    this.modalRef = this.modalService.open(content, { windowClass: 'custom-modal' })
  }

  openRattachement(contentRattachement: any) {
    this.modalRef = this.modalService.open(contentRattachement, { windowClass: 'custom-modal' })
  }

  fermer(){
    this.modalRef?.close()
}

  goDownloadApp(){
    location.href='https://tf.orange.com/f/97597fc33d9149f79714/?dl=1'
  }
}